import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { FormControl } from '@angular/forms';
import { SelectFilterEntry } from './entity';

@Component({
  selector: 'cc-integration-type-filter',
  templateUrl: './integration-type-filter.component.html',
  styleUrls: ['./integration-type-filter.component.scss']
})
export class IntegrationTypeFilterComponent implements OnInit {
  @Input() entries: SelectFilterEntry[];
  @Input() label: string;
  @Input() titleTranslateKey: string;
  @Input() allSelected: boolean;
  @Output() selectionChange = new EventEmitter();
  public indeterminate: boolean;
  @ViewChild('selector') selector: MatSelect;
  public selectedEntries = new FormControl();
  public displayLabel = '';

  constructor() {}

  ngOnInit() {
    this.liveUpdateSelectedValue();
  }

  private liveUpdateSelectedValue() {
    this.selectedEntries.valueChanges.subscribe((selectedValues: number[]) => {
      this.updateDisplayValue(selectedValues);
    });
  }

  private updateDisplayValue(selectedValues: number[]) {
    if (!selectedValues || !selectedValues.length) {
      this.displayLabel = '';
      return;
    }
    const firstValue = this.selectedEntries.value[0];
    this.displayLabel = firstValue;
  }

  selectionChanged(selectedKey) {
    this.indeterminate =
      this.selectedEntries.value.length > 0 && this.selectedEntries.value.length < this.entries.length;
    this.allSelected = this.selectedEntries.value.length === this.entries.length;
    this.selectionChange.next(this.selectedEntries.value);
  }

  toggleAllSelect() {
    if (this.allSelected) {
      this.selector.options.forEach((item: MatOption, index: number) => {
        item.select();
      });
    } else {
      this.selector.options.forEach((item: MatOption) => item.deselect());
    }
  }
}
